import { __assign, __read } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import _merge from 'lodash/merge';
// changes import from 'baseui to baseui/styles
// TODO FIX STYLES
import { ThemeProvider as BaseUIThemProvider } from '../baseui/styles';
import usePrevious from '../hooks/usePrevious';
import useMemoizedStyletron from '../style/useMemoizedStyletron';
import SPACEWEB_THEME_VS_BASEUI_THEME from '../themes';
import { useIsomorphicLayoutEffect } from '../hooks/useIsomorphicLayoutEffect';
import { themeContext, useTheme } from './context';
var THEME_NAMES = ['hyperspace-light', 'space-light', 'space-dark', 'hyperspace-dark'];
var addDensityToTheme = function (theme, density) {
    var _a;
    return (__assign(__assign({}, theme), { theme: __assign(__assign({}, theme.theme), { density: density || ((_a = theme.theme) === null || _a === void 0 ? void 0 : _a.density) }) }));
};
export var ThemeProvider = function (props) {
    var theme = props.theme, children = props.children, elementToApplyClass = props.containerElement, density = props.density;
    var outerTheme = useTheme();
    var _a = __read(useMemoizedStyletron(), 2), baseUITheme = _a[1];
    if (typeof outerTheme === 'undefined' && typeof theme === 'undefined') {
        throw new Error('No Theme present in context & props');
    }
    var Provider = themeContext.Provider;
    var value = useMemo(function () {
        var _a, _b;
        if (theme) {
            var newTheme = void 0;
            if (typeof theme === 'function') {
                newTheme = theme(outerTheme);
            }
            else {
                var newThemeName = (_a = theme.theme) === null || _a === void 0 ? void 0 : _a.name, outerThemeName = (_b = outerTheme === null || outerTheme === void 0 ? void 0 : outerTheme.theme) === null || _b === void 0 ? void 0 : _b.name, 
                // theme should be merged if both the outerTheme & themeToOverride has same name
                shouldMergeThemes = !newThemeName || !outerThemeName || newThemeName === outerThemeName;
                if (shouldMergeThemes) {
                    newTheme = _merge({}, outerTheme, theme);
                }
                else {
                    newTheme = __assign({ direction: outerTheme === null || outerTheme === void 0 ? void 0 : outerTheme.direction }, theme);
                }
            }
            if (typeof newTheme !== 'object') {
                throw new Error('theme has to be an object of shape {theme : {}, classes : {}}');
            }
            return addDensityToTheme(newTheme, density);
        }
        return addDensityToTheme(outerTheme, density);
    }, [theme, outerTheme, density]);
    var themeName = value.theme.name, prevThemName = usePrevious(themeName), containerElement = elementToApplyClass, prevContainerElement = usePrevious(containerElement);
    useIsomorphicLayoutEffect(function () {
        prevThemName && (prevContainerElement === null || prevContainerElement === void 0 ? void 0 : prevContainerElement.classList.remove(prevThemName));
        THEME_NAMES.forEach(function (name) { return containerElement === null || containerElement === void 0 ? void 0 : containerElement.classList.remove(name); });
        containerElement === null || containerElement === void 0 ? void 0 : containerElement.classList.add(themeName);
    }, [themeName, prevThemName, containerElement, prevContainerElement]);
    var baseuiThemeWithDirection = useMemo(function () { return (__assign(__assign({}, SPACEWEB_THEME_VS_BASEUI_THEME[themeName]), { direction: value.direction || 'ltr' })); }, [value.direction, themeName]);
    /**
     * Box component/styled cannot be used here as styletron might not be initialized when ThemeProvider renders for the first time.
     */
    return (_jsx("div", __assign({ "data-testid": "theme-provider-container", style: { display: 'contents' }, className: elementToApplyClass ? undefined : themeName }, { children: _jsx(BaseUIThemProvider, __assign({ theme: baseuiThemeWithDirection !== null && baseuiThemeWithDirection !== void 0 ? baseuiThemeWithDirection : baseUITheme }, { children: _jsx(Provider, __assign({ value: value }, { children: children }), void 0) }), void 0) }), void 0));
};
